<template>
    <CCard v-if="!item.ad" :style="{'background-color': backgroundColor}">
        <CCardBody>
            <CRow>
                <div class="col-sm-4" style="text-align: center">
                    <img :src="item.type_vehicle.logo" width="150" />
                </div>
                <div class="col-sm-6">
                    <label class="label">
                       {{item.name_vehicle}}
                    </label>
                    <CRow>
                        <div class="col-sm-2">
                            <label class="label">
                                En:
                            </label>
                        </div>
                        <div class="col-sm-10">
                            <label class="label">
                                {{item.municipality}}
                                {{item.state.name}}
                            </label>
                        </div>
                    </CRow>
                </div>
                <a class="col-sm-12">
                    <div class="btn-detail" @click="onShowItem(item)"> 
                        {{ $t('vehicles.detail') }}
                    </div>
                </a>
            </CRow>
        </CCardBody>
    </CCard>
    <CCard v-else>
        <CCardBody>
            <a :href="item.advertisement.url">
                <img :src="item.advertisement.path" style="height: 100%; width: 100%; object-fit: cover;"/>
            </a>
        </CCardBody>
    </CCard>
</template>

<script>
import store from '../../../store'

export default {
    name: "VehicleItem",
    props: ['item'],
    computed: {
        backgroundColor() {
            let self = this;
            return self.item.type_vehicle.color;
        }
    },
    methods: {
        onShowItem() {
            this.$emit('onShowItem', this.item);
        }
    }
}
</script>

